import { Suspense } from 'react';
import { QueryClient } from '@tanstack/react-query';
import withLazyLoading from '../../hoc/withLazyLoading';
import { createCrumbHandle } from '../../utilities/auth';
import withPostHogTracker from '../../composeRouter';
import Loader from '../../globalComponents/loader/DPLoader';
import { scadaLoader } from '../../pages/visualization/scadaConfigurationModule/scadaLiveSimulation/loader';

const AssetConfiguration = withLazyLoading(
  () => import('../../pages/visualization/assetConfiguration')
);
const ScadaLiveSimulation = withLazyLoading(
  () => import('../../pages/visualization/scadaConfigurationModule/scadaLiveSimulation')
);
const LayoutVisualisationConfig = withLazyLoading(
  () => import('../../pages/LayoutVisualisationConfig')
);
const CreateAssets = withLazyLoading(
  () => import('../../pages/createAssets')
);
const AssetSurvey = withLazyLoading(
  () => import('../../pages/createAssets/AssetSurvey')
);
const WelspunDemo = withLazyLoading(
  () => import('../../pages/WelspunDemo')
);
const PageListing = withLazyLoading(
  () => import('../../pages/visualization/visualizationPages/pageListing')
);
const PagesConfiguration = withLazyLoading(
  () => import('../../pages/visualization/visualizationPages/pagesConfiguration')
);
const ScadaView = withLazyLoading(
  () => import('../../pages/visualization/scadaConfigurationModule/scadaLiveSimulation/scadaView')
);
const TemplateListing = withLazyLoading(
  () => import('../../pages/visualization/visualizationTemplates/templateListing')
);
const TemplateConfiguration = withLazyLoading(
  () => import('../../pages/visualization/visualizationTemplates/templateConfiguration')
);

const visualizationRoutes = (queryClient: QueryClient) => [
  {
    path: '/visualization-configuration/:workspaceId/:assetId?/:id?/*',
    element: <AssetConfiguration />,    
    // authz-v2 TODO: Visualisation_Configuration_WE — gate server-side / useCan at component level
    handle: createCrumbHandle('Asset Configuration'),
  },
  {
    path: '/plant-view/:workspaceId',
    element: withPostHogTracker(<ScadaLiveSimulation />),
    loader: async (args: any) => {
      // authz-v2 TODO: route gate removed; server-enforced
      return scadaLoader(queryClient)(args);
    },
    children: [
      {
        path: ':assetId?/*',
        index: true,
        element: (
          <Suspense fallback={<Loader />}>
            <ScadaView />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/asset-creation/:id?',
    element: <CreateAssets />,    
    // authz-v2 TODO: Visualisation_Configuration_WE — gate server-side / useCan at component level
    handle: createCrumbHandle('Create Asset'),
  },
  {
    path: '/asset-survey/:workspaceId/:assetId?',
    element: <AssetSurvey />,    
    // authz-v2 TODO: PlantsList_Manage_A — gate server-side / useCan at component level
    handle: createCrumbHandle('Asset Survey'),
  },
  {
    path: '/LayoutVisualisationConfig/:workspaceId',
    element: <LayoutVisualisationConfig />,    
    // authz-v2 TODO: Visualisation_Configuration_WE — gate server-side / useCan at component level
    handle: createCrumbHandle('Asset Configuration'),
  },
  {// @obsolete
    path: '/WelspunDemo/:assetId',
    element: <WelspunDemo key={'WelspunDemo'} />,    
    handle: createCrumbHandle('Welspun Demo'),
  },
  { // @obsolete
    path: '/METL/:assetId',
    element: <WelspunDemo key={'METL'} />,    
    handle: createCrumbHandle('METL'),
  },
  {
    path: '/pages/:workspaceId',
    handle: createCrumbHandle('Pages'),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loader />}>
            <PageListing />
          </Suspense>
        ),
      },
      {
        path: ':pageId',
        element: <PagesConfiguration />,
        handle: createCrumbHandle('Configuration'),
      },
    ]
  },
  {
    path: '/visualization-templates',
    handle: createCrumbHandle('Templates'),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loader />}>
            <TemplateListing />
          </Suspense>
        ),
      },
      {
        path: 'new-template',
        element: <TemplateConfiguration />,
        handle: createCrumbHandle('New Template'),
      },
      {
        path: ':templateId',
        element: <TemplateConfiguration />,
        handle: createCrumbHandle('Edit Template'),
      },
    ]
  },
];

export default visualizationRoutes;
